import React, { Component } from 'react'

class DeferImage extends Component {
  /* constructor(props) {
    super(props)
    this.loadDeferredImage = this.loadDeferredImage.bind(this)
  }

  componentDidMount() {
    window.addEventListener('load', this.loadDeferredImage)
  }

  componentWillReceiveProps(nextProps) {
    if (this.imageRef) {
      this.imageRef.setAttribute('src', nextProps.src)
    }
  }

  loadDeferredImage() {
    if (this.imageRef) {
      this.imageRef.setAttribute('src', this.props.src)
    }
  } */

  render() {
    return (
      <img
        className={this.props.className}
        style={this.props.style}
        alt={this.props.alt}
        aria-hidden
        ref={imageRef => {
          this.imageRef = imageRef
        }}
        /* src={this.props.emptySrc || 'data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='} */
        src={this.props.src}
      />
    )
  }
}

export default DeferImage



// WEBPACK FOOTER //
// ./src/components/DeferImage.js